import { render } from "./OverviewHeading.vue?vue&type=template&id=f3860c1c"
import script from "./OverviewHeading.vue?vue&type=script&lang=js"
export * from "./OverviewHeading.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__